import { createContext, useContext, useState, ReactNode } from 'react';
import { FeedbackContextData } from "@/feedback/types";

interface FeedbackContextType {
  isOpen: boolean;
  contextData: FeedbackContextData | null;
  openFeedback: (context?: FeedbackContextData) => void;
  closeFeedback: () => void;
}

const FeedbackContext = createContext<FeedbackContextType | undefined>(undefined);

interface FeedbackProviderProps {
  children: ReactNode;
}

export const FeedbackProvider: React.FC<FeedbackProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [contextData, setContextData] = useState<FeedbackContextData | null>(null);

  const openFeedback = (context: FeedbackContextData | null = null): void => {
    setContextData(context);
    setIsOpen(true);
  };

  const closeFeedback = (): void => {
    setIsOpen(false);
    setContextData(null);
  };

  return (
    <FeedbackContext.Provider value={{
      isOpen,
      contextData,
      openFeedback,
      closeFeedback
    }}>
      {children}
    </FeedbackContext.Provider>
  );
};

export const useFeedback = (): FeedbackContextType => {
  const context = useContext(FeedbackContext);
  if (!context) {
    throw new Error('useFeedback must be used within FeedbackProvider');
  }
  return context;
};